<modal
  [modalId]="'customer-form'"
  [modalSize]="'md'"
  (close)="modalCleanup()">
  <h3 class="d-inline text-capitalize" modal-title>{{this.customer == null ? 'Add Customer' : 'Edit Customer'}}</h3>
  <div class="modal-inner h-100 pt-3" modal-inner>
    <form class="d-flex flex-column" id="form" [formGroup]="form" autocomplete="off" (ngSubmit)="submitForm()">
      <div class="custom-field my-2">
        <label class="custom-field-label" for="customer-name">Customer Name</label>
        <custom-text-input inputId="customer-name" formControlName="name" placeholder=""
          [errorMessages]="nameErrors"></custom-text-input>
      </div>

      <div class="custom-field my-2">
        <label class="custom-field-label" for="customer-instance-url">Customer Instance Url</label>
        <custom-text-input inputId="customer-instance-url" formControlName="cloudInstanceUrl" placeholder=""
          [errorMessages]="cloudInstanceUrlErrors"></custom-text-input>
      </div>

      <div class="custom-field my-2">
        <label class="custom-field-label" for="customer-subdomain">Subdomain</label>
        <custom-text-input inputId="customer-subdomain" formControlName="subdomain" placeholder=""
          [errorMessages]="subdomainErrors"></custom-text-input>
      </div>

        <div class="custom-field my-2">
            <label class="custom-field-label" for="customer-tenant-id">Tenant Id</label>
            <custom-text-input inputId="customer-tenant-id" formControlName="tenantId" placeholder=""
              [errorMessages]="tenantIdErrors"></custom-text-input>
        </div>

        <div class="labelled-slider simple-slider">
          <span>Enabled:</span>
          <label class="switch">
            <input type="checkbox" formControlName="enabled">
            <span class="slider round"></span>
          </label>
        </div>

      <hr class="my-2" />

      <div class="modal-button-row mt-3 row px-3 justify-content-between" *ngIf="customer != null">
        <button
          class="custom-button custom-button-warn"
          id="delete"
          type="button"
          (click)="deleteCustomer()"
          [disabled]="requestInProgress">
          Delete
        </button>
        <button class="custom-button custom-button-flat" id="edit" type="submit" [disabled]="requestInProgress">
          Save Changes
        </button>
      </div>

      <div class="modal-button-row mt-3 row px-3 justify-content-end" *ngIf="customer == null">
        <button class="custom-button custom-button-flat" id="add" type="submit" [disabled]="requestInProgress">
          Add Customer
        </button>
      </div>
    </form>
  </div>
</modal>
